import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { OperatorService } from '../../../services/operator.service';
import { DataSharingService } from '../../../services/data-sharing.service';
import { finalize } from 'rxjs';
import { NotificationService } from '../../../services/notification.service';
import { NumericOnlyDirective } from '../../sharedComponents/directives';

@Component({
    selector: 'app-operator-installation-removal',
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        NumericOnlyDirective
    ],
    providers: [MessageService],
    templateUrl: './operator-installation-removal.component.html',
    styleUrl: './operator-installation-removal.component.scss'
})
export class OperatorInstallationRemovalComponent {
  tagNumber: string = '';
  isLoading: boolean = false;
  tagError: boolean = false;
  constructor(
    private router: Router,
    private operatorService: OperatorService,
    private notificationService: NotificationService,
    private dataSharingService: DataSharingService
  ) { }

  go() {
    if (!this.tagNumber) {
      this.notificationService.showError('Please enter a tag number');
      return;
    }

    this.isLoading = true;

    this.operatorService.getOperationByTagNumber(this.tagNumber)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (data) => {
          if (data && data.message) {
            this.tagError = true;
            this.notificationService.showError(data.message);
          }
          else if (data?.status === 200) {
            // Store data in the DataSharingService instead of sessionStorage
            this.dataSharingService.setOperationData(data.body);

            // Navigate to detail component and pass just the tag number in query params
            this.router.navigate(['app-operation-installation-removal-detail'], {
              queryParams: {
                tagNumber: this.tagNumber,
                dataAvailable: 'true'
              }
            });
          }
          else {
            this.tagError = true;
            this.notificationService.showError(`No operation found with tag number ${this.tagNumber}`);
          }
        },
        error: (error) => {
          this.notificationService.showError(`Failed to fetch operation data with tag number ${this.tagNumber}`);
        }
      });
  }
}